import React from 'react';
import { Box } from '@mui/material';
import { Link } from "react-router-dom";
import waglLogo from "../assets/images/wagl-logo.svg";
import waglLogoWhite from "../assets/images/wagl-logo--white.svg";

function Logo({ showOnMobile = false, invert = false}) {

  return (
    <Box sx={{ 
      display: { xs: showOnMobile ? 'flex' : 'none', md: showOnMobile ? 'none' : 'block' }, 
      flexGrow: showOnMobile ? 1 : 0
    }}>
      <Link to="/">
        <img src={invert ? waglLogoWhite : waglLogo} alt="Wagl" width="95" />
      </Link>
    </Box>
  )
}

export default Logo;